import { z } from "zod";

// isolatedDeclarations: define output shape as TS interface, annotate
// Zod const with z.ZodType<Interface> so tsc can emit declarations without
// reading across module boundaries (D-15 paranoid-strict tsconfig).
//
// exactOptionalPropertyTypes: optional `description` field typed as
// `string | undefined` to match ZodOptional's output type.

export interface PrintMode {
  id: string;
  label: string;
  description?: string | undefined;
  layout: "grouped-by-category" | "sequential" | "flight-style";
}

// D-04 full-shape locked in Phase 1 — Phase 15 builds renderer against this
// locked schema without requiring a schemaVersion bump.
// `cssSelector` is intentionally OMITTED from Phase 1 (RESEARCH reference HTML grep
// at line 660). Phase 15 decides whether to use convention-based DOM roots or add
// cssSelector additively then. Omission is enforced by the test that asserts
// rejection of {... cssSelector: '#print'}.
export const PrintMode: z.ZodType<PrintMode> = z.strictObject({
  id: z.string().min(1).max(50),
  label: z.string().min(1).max(100),
  description: z.string().max(500).optional(),
  layout: z.enum(["grouped-by-category", "sequential", "flight-style"]),
});
